import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './FilterButtons.pcss';
export const FilterButtons = ({ buttons, selectedValue, name, }) => {
    return (_jsxs("div", { className: "filters-wrapper", children: [_jsx("div", { className: "filter-button-name", children: name }), _jsx("div", { className: "filter-buttons-container", children: buttons.map(({ name, onClick, value }) => (_jsx("button", { onClick: onClick, className: selectedValue === value
                        ? 'filter-button--active'
                        : 'filter-button', children: name }, name))) })] }));
};
